<template>
  <button
    :id="`appButton${ariaLabel}`"
    :class="['btn', 'theme-group-3', { 'btn--outlined': outlined }, { 'btn--outlinedRectangle': outlinedRectangle }]"
    :disabled="isDisabled"
    :aria-label="ariaLabel"
    @click.prevent="onclick"
    @keyup.enter="onclick"
  >
    <label :for="`appButton${ariaLabel}`" class="iw-visuallyhidden">{{ ariaLabel }}</label>
    <div v-if="text" class="btn__text">{{ text }}</div>
    <slot></slot>
    <div :class="['btn__overlay', { 'btn__overlay--outlined': outlined }]" />
  </button>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    text: {
      type: String,
      default: ""
    },
    handler: {
      type: [Function, null],
      default: null
    },
    isDisabled: Boolean,
    outlined: Boolean,
    outlinedRectangle: Boolean,
    ariaLabel: {
      type: String,
      default: ""
    }
  },
  methods: {
    onclick(e) {
      if (this.handler) {
        this.handler(e);
        return;
      }
      this.$emit("click", e);
    }
  }
};
</script>

<style lang="scss">
.btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 46px;
  outline: none;
  font-size: 14px;
  font-family: $fontFamilyPrimary;
  font-weight: $font_bold;
  background-color: $group-3-color-4;
  color: $group-3-color-1;
  border: none;
  border-radius: 23px;
  cursor: pointer;

  &__overlay {
    position: absolute;
    border: none;
    border-radius: inherit;
    outline: none;
    width: 100%;
    height: 100%;

    &--outlined {
      border: solid 1.5px $group-3-color-4;
    }
  }

  &__text {
    z-index: 1;
  }

  &--outlined {
    background-color: $group-3-color-1;
    color: $group-3-color-2;
    border: solid 1.5px $group-3-color-4;
  }

  &--outlinedRectangle {
    background-color: $group-3-color-1;
    color: $group-3-color-4;
    height: 46px;
    border-radius: 4px;
    border: solid 1.5px $group-3-color-3-alpha-40;
    background-color: $group-3-color-4-alpha-04;
  }

  &:disabled {
    opacity: 0.3;
    cursor: initial;
  }

  &:hover:enabled {
    cursor: pointer;

    .btn__overlay {
      background-color: white;
      opacity: 0.16;

      &--outlined {
        background-color: $group-3-color-4;
        opacity: 0.04;
      }
    }
  }

  &:active:enabled {
    .btn__overlay {
      background-color: black;
      opacity: 0.1;
    }
  }
}
</style>
